import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import packageJson from '../package.json';

Sentry.init({
    dsn: 'https://9d9fe31d2d5649f79d1127233d3348f2@o547664.ingest.sentry.io/6505510',
    integrations: [],
    // release: packageJson.version,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_ENVIRONMENT,
});
// Install GTM based on environment configuration
function installGTM(containerId) {
    try {
        if (typeof window === 'undefined') return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
        document.head.appendChild(script);

        const nos = document.createElement('noscript');
        nos.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${containerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        if (document.body.firstChild) {
            document.body.insertBefore(nos, document.body.firstChild);
        } else {
            document.body.appendChild(nos);
        }
    } catch (e) {
        // fail silently; do not break app if GTM insertion fails
        // eslint-disable-next-line no-console
        console.warn('installGTM failed', e);
    }
}

// Only install GTM if container ID is configured in environment
const gtmContainerId = process.env.REACT_APP_GTM_CONTAINER_ID;
if (gtmContainerId) {
    installGTM(gtmContainerId);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
